import { useEffect, useState } from 'react';
import { hasUsefulPreview } from '../api/linkPreview';
import { imageSrc } from '../api/media';
import type { LinkPreviewDto } from '../api/types';

export default function LinkPreviewCard({ preview }: { preview: LinkPreviewDto }) {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    if (!preview.imageFileId) return;
    let alive = true;
    imageSrc(preview.imageFileId)
      .then((u) => alive && setSrc(u))
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [preview.imageFileId]);

  // Не удалось получить вообще ничего осмысленного — карточка была бы пустой рамкой,
  // лучше промолчать (ссылка в тексте сообщения уже кликабельна).
  if (!hasUsefulPreview(preview)) return null;

  return (
    <a
      className="link-preview-card"
      href={preview.url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
    >
      {src && <img className="link-preview-image" src={src} alt="" />}
      <div className="link-preview-body">
        {preview.siteName && <div className="link-preview-site">{preview.siteName}</div>}
        {preview.title && <div className="link-preview-title">{preview.title}</div>}
        {preview.description && <div className="link-preview-desc">{preview.description}</div>}
      </div>
    </a>
  );
}
